// --- Logic --------------------------------------------------------------------------------------

/**
 * Uploads overwrite the same S3 key, so a replaced avatar or logo keeps its old URL and the browser
 * happily serves the cached copy. Stamping a fresh version param forces a re-fetch of the new bytes
 * without a hard refresh.
 */
export const withCacheBust = (url: string | null, version: number = Date.now()): string | null => {
    if (!url) return null;
    const [base] = url.split("#");
    const withoutVersion = base.replace(/([?&])v=\d+(&|$)/, (_match, prefix: string, tail: string) =>
        tail === "&" ? prefix : prefix === "?" ? "" : ""
    );
    const separator = withoutVersion.includes("?") ? "&" : "?";
    return `${withoutVersion}${separator}v=${version}`;
};
